import React from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import { IoIosCheckmark } from "react-icons/io";

interface IProps {
  active: boolean;
  Label: string;
  data: string[];
  setData: (data: string[]) => void;
}
const CheckBox = ({ active, Label, data, setData }: IProps) => {
  const OnClick = () => {
    if (active) {
      const newData = data.filter((value) => value !== Label);
      if (newData.length === 0) {
        return;
      }
      setData(newData);
    } else {
      const newData = [...data, Label];
      setData(newData);
    }
  };

  const baseColorMap: Record<string, string> = {
    Spotify: "#25CF5E",
    "Apple Music": "#F1465C",
    Deezer: "#A238FF",
    Amazon: "#2B94D0",
    Youtube: "#FF0000"
  };

  return (
    <Container
      active={active ? "true" : "false"}
      onClick={OnClick}
      color={baseColorMap[Label]}
    >
      {active ? <IoIosCheckmark color={Colors.grey900} size={24} /> : <></>}
    </Container>
  );
};

export default CheckBox;

const Container = styled.div<{ color: string; active: string }>`
  cursor: pointer;
  width: 1.6rem;
  height: 1.6rem;
  border: ${(props) =>
    props.active === "true" ? "" : `1px solid ${Colors.grey600}`};
  border-radius: 4px;
  background-color: ${(props) => (props.active === "true" ? props.color : "")};
  display: flex;
  justify-content: center;
  align-items: center;
`;
